(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function reveal(el) { el.classList.add('is-visible'); }

  function revealAll(root) {
    root.querySelectorAll('[data-entrance], [data-entrance-image]').forEach(reveal);
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      revealAll(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function init() {
    /* Hero — reveal on page load (double rAF ensures initial paint) */
    var hero = document.querySelector('.carelli-hero');
    if (hero) {
      var heroContainer = hero.querySelector('.carelli-hero__container');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (heroContainer) heroContainer.classList.add('is-hero-visible');
          revealAll(hero);
        });
      });
    }

    /* Scroll-triggered sections */
    document.querySelectorAll('[data-entrance-section]').forEach(function (s) {
      observer.observe(s);
    });

    /* Fallback: reveal sections already in viewport (catches direct loads where IntersectionObserver fires late) */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.querySelectorAll('[data-entrance-section]').forEach(function (s) {
          var rect = s.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0) {
            revealAll(s);
          }
        });
      });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
